/**
 * Détermine le niveau de permission d'un utilisateur pour un deal donné
 * @param {Object} dealData - Les données du deal
 * @param {Object} userData - Les données de l'utilisateur connecté
 * @returns {Object} { level: string, isSales: boolean, isProducer: boolean, isReferent: boolean }
 */
export const getUserPermissionLevel = (dealData, userData) => {
    if (!dealData || !userData) {
        return {
            level: 'producer',
            isSales: false,
            isProducer: false,
            isReferent: false
        };
    }

    const userRole = userData.role;
    const userId = userData.userId;

    // Déterminer les rôles spécifiques
    const isSales = dealData.sales && dealData.sales.some(sale => sale.ressource.id === userId);
    const isProducer = dealData.producers && dealData.producers.some(producer => producer.id === userId);
    const isReferent = dealData.reference_owner_id === userId;
    const isProductionLead = dealData.production_lead && dealData.production_lead.id === userId;

    // Règles pour les rôles avec permissions complètes
    if (userRole === 'OM' || userRole === 'PA') {
        return {
            level: 'full',
            isSales: true,
            isProducer: true,
            isReferent: true
        };
    }

    // Règle pour MA : doit être le manager du DAS du deal
    if (userRole === 'MA' && dealData.das_manager && dealData.das_manager.id === userId) {
        return {
            level: 'full',
            isSales: true,
            isProducer: true,
            isReferent: true
        };
    }

    // Règles pour les consultants (CO) et les managers (MA) non-manager du DAS
    if (userRole === 'CO' || userRole === 'MA') {
        // Priorité 1: Responsable de production (full)
        if (isProductionLead) {
            return {
                level: 'full',
                isSales: isSales,
                isProducer: isProducer,
                isReferent: isReferent
            };
        }

        // Priorité 2: Responsable commercial (sales)
        if (isSales) {
            return {
                level: 'sales',
                isSales: true,
                isProducer: isProducer,
                isReferent: isReferent
            };
        }

        // Priorité 3: Producteur avec référence (producer_referent)
        if (isProducer && isReferent) {
            return {
                level: 'producer_referent',
                isSales: false,
                isProducer: true,
                isReferent: true
            };
        }

        // Priorité 4: Producteur simple (producer)
        if (isProducer) {
            return {
                level: 'producer',
                isSales: false,
                isProducer: true,
                isReferent: false
            };
        }
    }

    // Par défaut, permissions limitées
    return {
        level: 'producer',
        isSales: false,
        isProducer: false,
        isReferent: false
    };
};
